






































import { Component, mixins } from 'nuxt-property-decorator';

import { useSubNavigation } from '@/composables/page-navigation';
import { useLatestNews } from '@/composables/latest-news';
import { PageContentMixin } from '@/composables/page-content';

import { NewsListingContentDataFragment } from '@/graphql/generated';
import { ComposableMixin } from '@/mixins/composable';

@Component
export default class NewsIndexPage extends mixins(
  PageContentMixin<NewsListingContentDataFragment>(),
  ComposableMixin(useLatestNews),
  ComposableMixin(useSubNavigation),
) {
  get page () {
    return {
      title: this.pageContent.title,
      slug: '',
      backgroundColor: 'white',
    };
  }

  intersected () {
    this.fetchMoreNews();
  }
}
